export const removeUnsupportedChars = (string: string) => {
  return string
    .trim()
    .replace(/  +/g, ' ')
    .replace(/[^\u0000-\uFFFF]/g, '');
};
